<form
  (ngSubmit)="handleSubmitClick()"
  [formGroup]="form">
  <div class="flex h-full items-stretch gap-6">
    <div class="w-100">
      <app-form-control
        [withBottomMargin]="false"
        label="Zdjęcie główne">
        <app-multimedia-choose-or-upload-control
          [formControl]="form.controls.featuredFile" />
      </app-form-control>

      <app-form-control
        [withBottomMargin]="false"
        label="Symbol boxa kosmetycznego">
        <app-multimedia-choose-or-upload-control
          [formControl]="form.controls.symbolFile" />
      </app-form-control>

      <app-form-control
        [withBottomMargin]="false"
        label="Zdjęcie podglądu zawartości boxa">
        <app-multimedia-choose-or-upload-control
          [formControl]="form.controls.illustrationFile" />
      </app-form-control>

      <app-form-control label="Galeria">
        <app-multimedia-choose-or-upload-multiple-control
          [formControl]="form.controls.files" />
      </app-form-control>
    </div>

    <div class="flex flex-1 flex-col bg-gray-50 p-6">
      <div>
        <app-form-control label="Nazwa">
          <input
            [formControl]="form.controls.name"
            appPrimengInputText
            pInputText
            placeholder="Wprowadź nazwę" />
        </app-form-control>

        <app-form-control label="Odpowiednik magazynowy">
          <p-select
            (onFilter)="handleWarehouseGoodSelectFilterChange($event)"
            [filter]="true"
            [formControl]="form.controls.warehouseProductId"
            [options]="valueOrDefault(warehouseGoodSelectItems$ | async, [])"
            appPrimengSelect
            [fluid]="true"
            placeholder="Wybierz powiązany produkt z magazynu" />

          <app-warehouse-good-usage-status
            [currentObjectId]="data()?.id"
            [currentObjectType]="warehouseGoodType.Box"
            [goodId]="currentGoodId$ | async" />
        </app-form-control>

        <div class="grid gap-4 xl:grid-cols-2">
          <app-form-control label="Cena">
            <p-input-number
              [fluid]="true"
              [formControl]="form.controls.price"
              [min]="0"
              currency="PLN"
              mode="currency"
              placeholder="Wprowadź cenę" />
          </app-form-control>

          @if (isEditContext()) {
            <app-form-control label="Slug">
              <input
                [formControl]="form.controls.slug"
                placeholder="Wprowadź slug"
                appPrimengInputText
                pInputText />
            </app-form-control>
          }

          <app-form-control label="Marka kosmetyczna">
            <p-select
              [filter]="true"
              [formControl]="form.controls.cosmeticBrandId"
              [options]="valueOrDefault(brandSelectItems$ | async, [])"
              appPrimengSelect
              [fluid]="true"
              placeholder="Wybierz markę kosmetyczną" />
          </app-form-control>

          <app-form-control label="Kategoria boxa">
            <p-select
              [filter]="true"
              [formControl]="form.controls.boxCategoryId"
              [options]="valueOrDefault(boxCategorySelectItems$ | async, [])"
              appPrimengSelect
              [fluid]="true"
              placeholder="Wybierz kategorię boxa" />
          </app-form-control>

          <app-form-control
            hint="Pozostawienie tego pola pustego oznacza brak limitu."
            label="Maksymalna ilość sztuk w zamówieniu">
            <p-input-number
              [fluid]="true"
              [formControl]="form.controls.maxQuantityPerOrder"
              [min]="0"
              placeholder="Wprowadź maksymalną ilość sztuk" />
          </app-form-control>

          <app-form-control
            hint="Pozostawienie tego pola pustego oznacza brak limitu."
            label="Dostępna ilość do kupienia">
            <p-input-number
              [fluid]="true"
              [formControl]="form.controls.availableQuantity"
              [min]="0"
              placeholder="Wprowadź dostępną ilość" />
          </app-form-control>

          <app-form-control
            inputId="a56225c4-8c83-4989-bd95-405a07289335"
            label="Aktualnie w sprzedaży">
            <app-checkbox-with-label
              inputId="a56225c4-8c83-4989-bd95-405a07289335"
              type="short">
              <p-checkbox
                [binary]="true"
                [formControl]="form.controls.currentEdition" />

              <span label>Edycja aktualnie w sprzedaży</span>
            </app-checkbox-with-label>

            <span class="mt-2 text-sm text-orange-500">
              Zmieniając aktualnie sprzedawaną edycję, zweryfikuj ilość
              dostępnych produktów, pakietów i subskrypcji.
            </span>
          </app-form-control>

          <app-form-control label="Adres URL do podglądu zawartości">
            <input
              [formControl]="form.controls.contentPreviewUrl"
              appPrimengInputText
              pInputText
              placeholder="Wprowadź adres URL" />
          </app-form-control>

          @if (isEditContext()) {
            <app-form-control label="Data pierwszej publikacji">
              <p-date-picker
                [formControl]="form.controls.publishedAt"
                placeholder="Wybierz datę publikacji" />
            </app-form-control>
          }

          <app-form-control label="Status">
            <p-select
              [formControl]="form.controls.status"
              [options]="valueOrDefault(boxStatusSelectItems$ | async, [])"
              appPrimengSelect
              [fluid]="true"
              placeholder="Wybierz status" />
          </app-form-control>

          @if (shouldPasswordVisible$ | async) {
            <app-form-control label="Hasło">
              <p-password
                [fluid]="true"
                [formControl]="form.controls.password"
                appPrimengPassword
                autocomplete="off"
                placeholder="Wprowadź hasło" />
            </app-form-control>
          }
        </div>

        <app-form-control
          hint="Wybierz kosmetyki powiązane z tym boxem."
          label="Kosmetyki">
          <app-admin-box-cosmetics-control
            [formControl]="form.controls.cosmetics" />
        </app-form-control>

        <app-form-control
          hint="Przykład: opis, składniki"
          label="Charakterystyka produktu">
          <app-admin-box-characteristics-control
            [formControl]="form.controls.characteristics" />
        </app-form-control>
      </div>

      <div class="mt-auto flex justify-end">
        <p-button
          [disabled]="form.invalid"
          appPrimengButton
          label="Zapisz"
          severity="primary"
          type="submit" />
      </div>
    </div>
  </div>
</form>
